export interface ActionButtonConfig {
  width: string;
  variant: string;
  size: string;
  border: string;
  background?: string;
  color: string;
  hoverBg: string;
  hoverColor?: string;
  translationKey: string;
}

export interface ActionConstants {
  pending: ActionButtonConfig;
  completed: ActionButtonConfig;
  failed: ActionButtonConfig;
  inProgress: {
    color: string;
    translationKey: string;
  };
  processingSources: ActionButtonConfig;
  irrelevantDoc: ActionButtonConfig;
}

export const ACTION_CONSTANTS: ActionConstants = {
  pending: {
    width: "130px",
    variant: "outline",
    size: "sm",
    border: "1px solid #1C00B8",
    background: "#1C00B8",
    color: "#FFFFFF",
    hoverBg: "#1C00B8",
    hoverColor: "#FFFFFF",
    translationKey: "assessments.actions.startAnalysis",
  },
  completed: {
    width: "130px",
    variant: "outline",
    size: "sm",
    border: "1px solid #00B883",
    color: "#00B883",
    hoverBg: "#059669",
    hoverColor: "#FFFFFF",
    translationKey: "assessments.actions.viewOutput",
  },
  failed: {
    width: "130px",
    variant: "outline",
    size: "sm",
    border: "1px solid #1C00B8",
    color: "#1C00B8",
    hoverBg: "#1C00B8",
    hoverColor: "#FFFFFF",
    translationKey: "assessments.actions.retry",
  },
  inProgress: {
    color: "#3AB65A",
    translationKey: "assessments.actions.inProgress",
  },
  processingSources: {
    width: "160px",
    variant: "outline",
    size: "sm",
    border: "1px solid #06B6D4",
    color: "#06B6D4",
    hoverBg: "#0891B2",
    hoverColor: "#FFFFFF",
    translationKey: "assessments.actions.processingSources",
  },
  irrelevantDoc: {
    width: "130px",
    variant: "outline",
    size: "sm",
    border: "1px solid #E77E07",
    color: "#E77E07",
    hoverBg: "#E77E07",
    hoverColor: "#FFFFFF",
    translationKey: "assessments.actions.irrelevantDoc",
  },
};

export const ASSESSMENT_STATUS = {
  PENDING: "pending",
  COMPLETED: "completed",
  IN_PROGRESS: "in_progress",
  PROCESSING_SOURCES: "processing_sources",
  FAILED: "failed",
  IRRELEVANT_DOC: "irrelevant_doc",
} as const;

export const TABLE_STYLES = {
  headerBg: "#B8590014",
  headerTextColor: "#1A202C",
  headerFontSize: "14px",
  headerFontWeight: "600",
  cellPadding: 4,
  borderRadius: "12px",
  hoverBg: "gray.50",
} as const;
